<template>
    <div class="page send-verify">

        <div class="title">
            输入验证码
            <div class="desc">
                验证码已发送至 {{tel}}
            </div>
        </div>

        <div class="content">
            <div class="cancel_otp_code_box">
                <div class="otpInputs">
                    <input v-enterfocus ref="otpInputs" type="number" v-model="code" @keydown.delete="changeCode">
                    <span class="code_list">{{code1}}</span>
                    <span class="code_list">{{code2}}</span>
                    <span class="code_list">{{code3}}</span>
                    <span class="code_list last_code_list">{{code4}}</span>
                </div>
                <p class="error_text" :class="{show: error}">Please try again</p>
            </div>
        </div>

        <div class="control">
            <div class="control-btn">
                <van-button :disabled="disabled" color="#0FB7AD" round size="small" @click="sendVerify()">
                    {{disabled && restTime > 0?`重新发送 ${restTime}s`:'重新发送'}}
                </van-button>
            </div>
            <div class="login-back" @click="$router.push({name:'login'})">
                <img src="/static/img/icon_mycenter_back.svg" style="width: 16px;margin-bottom: -3px;" alt="">
                更换手机号
            </div>
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                tel:"",
                code: '',
                code1: '',
                code2: '',
                code3: '',
                code4: '',
                flag: 0,
                restTime: 60,
                error: false,
                disabled: true,
                is_register:1

            }
        },
        watch: {
            code (val) {
                if (val) {
                    this.code = val.length > 4 ? val.substr(0, 4) : val;
                    let arr = val.split('');
                    this.code1 = arr[0];
                    this.code2 = arr[1];
                    this.code3 = arr[2];
                    this.code4 = arr[3];
                    if (val.length === 4){
                        Interface.getData('post',Interface.user.check_verify, {
                            mobile: this.tel.replace(/ /g,""),
                            code : this.code,
                            openid : localStorage.getItem("openid"),
                            union_id:localStorage.getItem("union_id"),
                            refer:sessionStorage.getItem("back-url"),
                        }).then(res => {
                            if (res.code == 0) {
                                if(res.data.user.new_reg_complete == "0"){
                                    this.$router.push({
                                        name : "add-info",
                                        query : {tel:this.tel}
                                    })
                                }else{
                                    localStorage.setItem('user', JSON.stringify(res.data.user))
                                    localStorage.setItem('access_token', res.data.access_token)
                                    localStorage.setItem('user_id', res.data.user.id)
                                    localStorage.setItem('uuid', res.data.user.uuid)
                                    this.$toast.success("登录成功");

                                    let apply = sessionStorage.getItem("apply")
                                    if(apply){
                                        this.$router.push({
                                            name:"add-info"
                                        })
                                        return
                                    }

                                    setTimeout(()=>{
                                        let back = sessionStorage.getItem("back-url")
                                        if(back != null){
                                            this.$router.push({
                                                path : back,
                                            })
                                        }else{
                                            this.$router.push({
                                                name : "home",
                                            })
                                        }
                                    },500)
                                }
                            } else{
                                this.$toast.fail(res.message);
                            }
                        })
                    }
                }
            }
        },
        methods: {
            startSendOTP () {
                var timer = setInterval(() => {
                    this.restTime--;
                    if (this.restTime <= 0) {
                        this.restTime = 0;
                        this.disabled = false;
                        clearInterval(timer);
                    } else {
                        this.disabled = true;
                    }
                }, 1000);
            },
            sendVerify(){
                let phoneValue = this.tel;
                Interface.getData('get',Interface.user.send_verify, { mobile: phoneValue.replace(/ /g,""),is_register:+0 })
                    .then(res => {
                        if (res.code !== -1) {
                            this.restTime = 60
                            this.startSendOTP()
                        }
                    })
            },
            changeCode (e) {
                if (this.code.split('').length <= 1) {
                    this.code = '';
                    this.code1 = '';
                }
                this.$refs.otpInputs.focus();
            },
            confirmCancel () {
                let data = this.OTPdata;
                data['otp'] = `${this.code1}${this.code2}${this.code3}${this.code4}`;
                this.$http.post(applyForRefundTogether, data).then(res => {
                    if (res.code === 200 && res.succ) {
                        this.error = false;
                        Toast('Cancel Successfully');
                    } else {
                        this.error = true;
                        Toast(res.msg);
                    }
                })
            },
            giveUpCancel () {
                this.$emit('giveUpCancel');
            }
        },
        filters: {
            keepSecrect (val) {
                let phone = val.split(' ');
                let head = phone[1].substr(0, 3);
                let tail = phone[1].substr(-3);
                return `${phone[0]} ${head}****${tail}`;
            }
        },
        directives: {
            enterfocus: { // 进入时激活input,可直接输入
                inserted: function (el) {
                    el.focus();
                }
            }
        },
        created() {
            this.tel = this.$route.query.tel
            this.is_register = this.$route.query.is_register
            this.startSendOTP()
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/send-verify/index.vue